import React from "react";
import { ElementsViewer } from "@wuilt/section-preview";
import useElements from "../hooks/useElements";
import { migrateElement } from "./social-icons-migration";
function SocialLinks(props) {
  const wuiltContext = useElements();
  const element = migrateElement(props.value?.id, props.value);
  if (element?.settings?.hidden) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ElementsViewer.SocialLinks, {
    element: element,
    wuiltContext: wuiltContext,
    customClassNames: {
      itemClass: props.itemClass,
      listClass: props.listClass,
      navLinksColor: props.navLinksColor,
      hiddenClass: ""
    }
  });
}
export default SocialLinks;
//# sourceMappingURL=SocialLinks.js.map